import type { IconSvgObject } from './types';

const Award02Icon: IconSvgObject = [
  ["path", { d: "M16 22V19C16 18.4477 15.5523 18 15 18H9C8.44772 18 8 18.4477 8 19V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9998 12V18", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 22H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8 13.5L12 12L16 13.5L15.5 9.5L18 6.5L14.5 5.5L12 2L9.5 5.5L6 6.5L8.5 9.5L8 13.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.55", key: "3" }]
];

export default Award02Icon;
